<template>
    <section class="background-image" style="height:80vh">
        <the-header></the-header>
        
        
        <div class=" pt-40 pb-20 h-full font-poppins">
            <div class=" flex justify-center">
                <p class=" text-4xl text-blue-600 font-bold md:text-xl">
                    Register as a CG Carrier
                </p>
            </div>

            <div class=" flex justify-center mt-10">
                <div>
                    <p class="bg-blue-400 text-center text-white pl-14 pr-14 pt-3 pb-3 rounded-xl"><router-link to="/step-one-registration">APPLY FOR HIRE PURCHASE</router-link></p>  
                    <p class="bg-blue-700 text-center text-white pl-14 pr-14 pt-3 pb-3 mt-3 rounded-xl"><router-link to="/dso-step-one-registration">APPLY AS A DSP</router-link></p>  
                    <p class="bg-blue-400 text-center text-white pl-14 pr-14 pt-3 pb-3 mt-3 rounded-xl"><router-link to="/dso-rider-registration">APPLY AS A DSP CARRIER</router-link></p>  
                </div>
            </div>
        </div>

        <div>
            <the-footer></the-footer>
        </div>

    </section>
</template>

<style scoped>
.background-image {
    background-image:linear-gradient(rgb(255, 255, 255, 0.6), rgba(255,255,255,0.5)), url('../Images/image 27.png');
    background-repeat: no-repeat;  
    background-size: cover;  
    height: 100vh;
}
</style>
